module.exports = __webpack_public_path__ + "img/4-4.72cf948f.svg";